'use client'

import { showError } from '@/components/atoms/show-error'
import { Button, Modal, Select, Stack, TextInput } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { IconCheck } from '@tabler/icons-react'
import type { ReactNode } from 'react'
import { useState } from 'react'
import { useServerAction } from 'zsa-react'
import { updateBabyName } from '../editar-perfil/_actions/updateBabyName'

const BUTTON_PROPS = {
	c: 'rgb(168, 105, 170)',
	color: 'rgb(168, 105, 170)',
	radius: 'xl',
	variant: 'outline',
}

interface BabyNameModalProps {
	children: ReactNode
	id: string
	currentName?: string
	isEditable: boolean
	currentEventType?: string
}

export function BabyNameModal({ children, id, currentName, currentEventType, isEditable }: BabyNameModalProps) {
	const [opened, { open, close }] = useDisclosure(!currentName)
	const [name, setName] = useState(currentName)
	const [isSuccess, setIsSuccess] = useState(false)
	const [eventType, setEventType] = useState(currentEventType || 'Chá de Bebê')
	const { isPending, execute } = useServerAction(updateBabyName)

	const handleClose = () => {
		if (!name) {
			showError('Por favor, digite o nome do bebê')
			return
		}

		close()
	}

	return (
		<>
			<div onClick={isEditable ? open : undefined} className="cursor-pointer">
				{children}
			</div>

			<Modal opened={opened} onClose={handleClose} title="Editar nome do bebê" size="md" centered>
				<Stack align="center" gap="md">
					<TextInput
						label="Nome do bebê"
						placeholder="Digite o nome do bebê"
						value={name}
						onChange={event => setName(event.currentTarget.value)}
						style={{ width: '100%' }}
					/>

					<Select
						label="Tipo de evento"
						placeholder="Selecione o tipo de evento"
						data={['Chá de Bebê', 'Chá Revelação', 'Chá de Fraldas', 'Chá Rifa', 'Batizado']}
						clearable
						value={eventType}
						className="w-full"
						onChange={event => setEventType(event || 'Chá de Bebê')}
					/>

					<Button
						leftSection={isSuccess ? <IconCheck /> : null}
						loading={isPending}
						{...BUTTON_PROPS}
						onClick={async () => {
							if (!name) {
								showError('Por favor, digite o nome do bebê')
								return
							}

							await execute({
								name,
								profileId: Number(id),
								eventType: eventType || 'Chá de Bebê',
							})

							close()
							window.location.reload()

							setIsSuccess(true)
						}}
					>
						{isSuccess ? <span>Salvo com sucesso</span> : <span>Salvar</span>}
					</Button>
				</Stack>
			</Modal>
		</>
	)
}
